import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import useSeo from "@/hooks/useSeo";
import Hero from "./components/Hero";
import RankingSection from "./components/RankingSection";
import CategorySection from "./components/CategorySection";
import NewSection from "./components/NewSection";
import BrandSection from "./components/BrandSection";
import FaqSection from "./components/FaqSection";
import { siteMeta } from "@/mocks/comics";

export default function Home() {
  useSeo({
    title: "韩国漫画yy排行榜精选 - 韩漫YY榜 人气榜单与完结漫画",
    description:
      "韩国漫画yy排行榜精选，韩漫人气榜单与完结漫画分类实时更新。新番抢先看，按分类快速定位想看的韩漫，追榜选书更高效，书荒时按榜单挑准没错。",
    keywords: "韩国漫画yy,韩国漫画yy排行榜,韩漫yy热门推荐,韩漫yy人气榜单,韩漫yy完结漫画",
    path: "/",
    structuredData: [
      {
        "@context": "https://schema.org",
        "@type": "WebSite",
        name: siteMeta.name,
        description: siteMeta.desc,
        url: window.location.origin,
        potentialAction: {
          "@type": "SearchAction",
          target: `${window.location.origin}/categories?q={search_term_string}`,
          "query-input": "required name=search_term_string",
        },
      },
      {
        "@context": "https://schema.org",
        "@type": "Organization",
        name: siteMeta.name,
        slogan: siteMeta.slogan,
        email: siteMeta.email,
      },
    ],
  });

  return (
    <div className="min-h-screen">
      <Navbar />
      <main>
        <Hero />
        <RankingSection />
        <CategorySection />
        <NewSection />
        <BrandSection />
        <FaqSection />
      </main>
      <Footer />
    </div>
  );
}